import { Component, Input, OnInit } from '@angular/core';
import { DynamicOptionsComponent } from '../dynamic-options';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { CategoriesService } from '../../../../../../data-services/categories.service';
import { TaxonomyOption } from '@vendasta/taxonomy';
import { map, startWith, switchMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-categories-options',
  templateUrl: './categories-options.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class CategoriesOptionsComponent implements OnInit, DynamicOptionsComponent {
  categoryOptionControl: UntypedFormControl = new UntypedFormControl(null, categoryValidator);
  categoryOptions$: Observable<TaxonomyOption[]> = this.categoriesService.categories$;
  selectedValue$ = this.categoryOptionControl.valueChanges;

  @Input() initialValue: string[];

  selectedLabels$: Observable<string[]>;
  firstSelectedLabel$: Observable<string>;

  constructor(private categoriesService: CategoriesService) {}

  ngOnInit(): void {
    if (Array.isArray(this.initialValue)) {
      this.categoryOptionControl.setValue(this.initialValue);
    }

    this.selectedLabels$ = this.selectedValue$.pipe(
      startWith((this.categoryOptionControl.value || []) as string[]),
      switchMap((selectedIds) => {
        return this.categoriesService.getNamesFromCategoryIDs(selectedIds as string[]);
      }),
    );
    this.firstSelectedLabel$ = this.selectedLabels$.pipe(map((selected) => selected[0] || ''));
  }

  getSelectedValue(): string {
    return this.categoryOptionControl?.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.categoryOptionControl];
  }

  isFormValid(): boolean {
    return this.categoryOptionControl.valid;
  }
}

function categoryValidator(control: AbstractControl): { [key: string]: any } {
  return Array.isArray(control.value) && control.value.length > 0 ? null : { error: false };
}
